import { logEvent } from "@Lib/analytics";
import styles from "./index.module.less";
import cx from "classnames";
import React, { useEffect } from "react";
import { g4, formatThousend } from "../../../../utils/helper";
import { Common } from "@Api";
import { formatNumberToUnitString } from "@t8891/utils";

const { postInitialCollect } = Common;

let TextMap = new Map([
  ["1", "領取優惠"],
  ["2", "一鍵詢價"],
  ["3", "規格配備"],
  ["4", "中古車"],
]);

class ArticleKindsItem extends React.Component {
  io = null;

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.scrollWatch(this.el);
  }

  componentDidUpdate() {
    const { data } = this.props;
    data.ads && postInitialCollect(data.ads, "show", "");
  }

  scrollWatch = (el) => {
    const { data } = this.props;
    let isFrist = false;

    try {
      this.io = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting && !isFrist) {
            isFrist = true;
            if (g4) {
              g4("element_exposured", {
                page_name: "影音詳情頁",
                module: "相關車款、競爭車款",
                element: "車款列表",
                element_id: "競爭&相關車款入口",
              });
              g4("element_exposured", {
                page_name: "影音詳情頁",
                module: "相關車款、競爭車款",
                element: "車款列表",
                element_id: TextMap.get(data.btnStatus),
              });
            }
          }
        },
        { threshold: [0.65] },
      );
      if (el) {
        this.io.observe(el);
      }
    } catch (e) {
      console.log(e);
    }
  };

  componentWillUnmount() {
    if (this.el) {
      this.io.unobserve(this.el);
    }
  }

  setTagIcon = (type) => {
    const { data, source } = this.props;

    const handleClickG4 = (e, text) => {
      e.stopPropagation();
      data.ads && postInitialCollect(data.ads, "click", "");
      g4("element_clicked", {
        page_name: "影音詳情頁",
        module: "相關車款、競爭車款",
        element: "車款列表",
        element_id: text,
      });
    };

    switch (type) {
      case "1":
        return (
          <a
            href={
              data.ads && data.ads.adclick !== ""
                ? data.ads.adclick
                : `https://c.8891.com.tw/ask/price?b=${data.brand_id}&k=${data.kind_id}&source=${
                    source || "影音內頁-領取優惠"
                  }`
            }
            className={cx(styles["btn"], styles[`btn-${type}`])}
            onClick={(e) => handleClickG4(e, "領取優惠")}
          >
            領取優惠
          </a>
        );
      case "2":
        return (
          <a
            href={
              data.ads && data.ads.adclick !== ""
                ? data.ads.adclick
                : `https://c.8891.com.tw/ask/price?b=${data.brand_id}&k=${data.kind_id}&source=${
                    source || "影音內頁-領取優惠"
                  }`
            }
            className={cx(styles["btn"], styles[`btn-${type}`])}
            onClick={(e) => handleClickG4(e, "一鍵詢價")}
          >
            一鍵詢價
          </a>
        );
      case "3":
        return (
          <a
            href={data.specLink}
            className={cx(styles["btn"], styles[`btn-${type}`])}
            onClick={(e) => handleClickG4(e, "規格配備")}
          >
            規格配備
          </a>
        );
      case "4":
        return (
          <a
            href={data.usedCarLink}
            className={cx(styles["btn"], styles[`btn-${type}`])}
            onClick={(e) => handleClickG4(e, "中古車")}
          >
            中古車
          </a>
        );
      default:
        break;
    }
  };

  render() {
    const { data, category } = this.props;

    return (
      <div
        className={styles["ArticleKindsItem"]}
        onClick={() => {
          logEvent(category, "相關文章", data.title);
        }}
        ref={(el) => (this.el = el)}
      >
        <a
          href={data.ads && data.ads.adclick !== "" ? data.ads.adclick : data.summaryLink}
          id='MoviesKindsLinkToSummary'
          className={styles["item"]}
          onClick={() => {
            g4("element_clicked", {
              page_name: "影音詳情頁",
              module: "相關車款、競爭車款",
              element: "車款列表",
              element_id: "競爭&相關車款入口",
            });
          }}
        >
          <img src={data.thumb} className={styles["img"]} alt={data.name} />
          <div className={styles["right"]}>
            <p className={styles["title"]}>{data.name}</p>
            <p className={styles["price"]}>{data.price}</p>
            {/* {this.setTagIcon(data.btnStatus)} */}

            <div className='h-68 pb-10 flex items-center flex-col justify-center'>
              {data.isInquiry == 1 && (
                <div className={"flex justify-center items-center mb-14"}>
                  <a
                    id='MoviesKindsLinkToAskPriceInstallment'
                    href={`/ask/price?b=${data.brand_id}&k=${data.kind_id}&source=影音詳情頁-相關車款-分期購車&kindType=installment`}
                    target='_blank'
                    className='flex items-center justify-center border-1 border-solid border-[#3264FF] text-[#3264FF] rounded-16 mr-8 h-30 text-16 px-14 hover:text-[#3264FF]'
                    onClick={(e) => e.stopPropagation()}
                  >
                    分期購車
                  </a>
                  <a
                    id={!!data?.discountPrice ? "MoviesKindsLinkToAskPriceDiscountPrice" : "MoviesKindsLinkToAskPrice"}
                    className='flex items-center justify-center border-1 border-solid border-[#FF4333] text-[#FF4333] rounded-16 h-30 text-16 px-14 hover:text-[#FF4333]'
                    target='_blank'
                    href={`/ask/price?b=${data.brand_id}&k=${data.kind_id}&source=${
                      !!data?.discountPrice ? "影音詳情頁-相關車款-領取優惠" : "影音詳情頁-相關車款-一鍵詢價"
                    }`}
                    onClick={(e) => e.stopPropagation()}
                  >
                    {!!data?.discountPrice ? "領取優惠" : "一鍵詢價"}
                  </a>
                </div>
              )}

              <div className='flex justify-center items-center'>
                <a
                  id='MoviesKindsLinkToPhotoModelBalance'
                  href={`/photoModel-balance.html?k=${data.kind_id}`}
                  target='_blank'
                  className={"text-[#666666] text-14 hover:text-[#666666]"}
                  onClick={(e) => e.stopPropagation()}
                >
                  規格配備
                </a>
                <i className='w-1 h-16 mx-6 bg-[#E8E8E8]' />
                <a
                  id='MoviesKindsLinkToArticleList'
                  href={`/kind-information/${data.kind_id}`}
                  target='_blank'
                  className={"text-[#666666] text-14 hover:text-[#666666]"}
                  onClick={(e) => e.stopPropagation()}
                >
                  編輯測評
                </a>
                <i className='w-1 h-16 mx-6 bg-[#E8E8E8]' />
                <a
                  id='MoviesKindsLinkToRatingList'
                  href={`/kind-comment/${data.kind_id}`}
                  target='_blank'
                  className={"text-[#666666] text-14 hover:text-[#666666]"}
                  onClick={(e) => e.stopPropagation()}
                >
                  車友評價
                </a>
              </div>
            </div>

            <a
              id={`MoviesMenusToSummary`}
              href={
                data.menuCount && data.menuCount !== "0" && data.menuCount !== ""
                  ? `/buy-car/menu?brandId=${data.brand_id}&kindId=${data.kind_id}`
                  : `/photoModel-info.html?k=${data.kind_id}`
              }
              target='_blank'
              style={{ background: "linear-gradient(90deg,#f2f7fe 5%, #d6e6fd)" }}
              className='w-full h-40 flex items-center justify-between text-[#666666] hover:text-[#666666] text-14 px-10 rounded-bl-4 rounded-br-4'
            >
              {data.menuCount && data.menuCount !== "0" && data.menuCount !== ""
                ? `${formatNumberToUnitString(Number(data.menuCount) || 0, {
                    needToLocalStringLessTenThousand: true,
                    digist: 1,
                  })}位車主分享成交行情`
                : data.visitsRank}
              <span className='text-[#3264FF] '>查看</span>
            </a>
          </div>
          {data.ads && data.ads.tag !== "" && <span className={styles["tag"]}>{data.ads.tag}</span>}
          {!!data.discountPrice && (
            <div className={styles["discount"]}>
              優惠禮包<span>{data.discountPrice}</span>
            </div>
          )}
        </a>
      </div>
    );
  }
}

export default ArticleKindsItem;
